import { useSyncExternalStore } from 'react';

let isAuthCheckFailed = false;
const listeners = new Set<() => void>();

export const setAuthCheckFailed = () => {
  if (isAuthCheckFailed) {
    return;
  }
  isAuthCheckFailed = true;
  listeners.forEach(l => l());
};

export const subscribeAuthCheckFailed = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getAuthCheckFailed = () => isAuthCheckFailed;

export const useAuthCheckFailed = (): boolean => useSyncExternalStore(subscribeAuthCheckFailed, getAuthCheckFailed);
